import { Component, OnInit, ElementRef } from '@angular/core';
import { Subscription } from 'rxjs/Subscription';
import { Observable } from 'rxjs/Rx';
import { MapsSidebarService } from '../../maps-sidebar.service';

@Component({
  selector: 'app-property-filter',
  templateUrl: './property-filter.component.html',
  styleUrls: ['./property-filter.component.less']
})
export class PropertyFilterComponent implements OnInit {
  isPropertyOn: boolean = true;

  glaSqftMinError: boolean = false;
  glaSqftMaxError: boolean = false;
  availableSqftMinError: boolean = false;
  availableSqftMaxError: boolean = false;

  closeOnClickRef: any;
  glaSqftMin: string = '';
  glaSqftMax: string = '';
  availableSqftMin: string = '';
  availableSqftMax: string = '';

  glaSqftMinElement: any;
  glaSqftMaxElement: any;
  availableSqftMinElement: any;
  availableSqftMaxElement: any;

  glaSqftMaxLengthError: boolean = false;
  isGlaSqftMaxFocus: boolean = false;
  availableSqftMaxLengthError: boolean = false;
  isAvailableSqftMaxFocus: boolean = false;

  propertyFiltersChangedSubscription: any;
  propertyFilterActiveSubscription: Subscription;
  propertyFiltersToggleSubscription: any;
  propertyTypeRadioSubscription: any;
  propertyResetFilterSubscription: any;

  organizationDetails: any;

  constructor(public mapsSidebarService: MapsSidebarService, public elementRef: ElementRef) { }

  ngOnInit() {
    let w = (<any>window);
    this.closeOnClickRef = this.closeOnOutsideClick.bind(this);
    this.propertyFilterActiveSubscription = this.mapsSidebarService.propertyFilterActiveStream.subscribe((value)=> {
      value && document.addEventListener('click', this.closeOnClickRef, true);
    });
  }

  ngAfterViewInit() {
    let w = (<any>window);
    this.glaSqftMinElement = document.getElementById('property-filter-gla-min');
    this.glaSqftMaxElement = document.getElementById('property-filter-gla-max');
    this.availableSqftMinElement = document.getElementById('property-filter-avail-min');
    this.availableSqftMaxElement = document.getElementById('property-filter-avail-max');

    this.propertyFiltersToggleSubscription = w.Events.subscribe('propertyFiltersToggle',(value)=>{
      this.toggleProperty(value);
    });

    this.propertyFiltersChangedSubscription = w.Events.subscribe('propertyFiltersChanged',()=>{
      if(w.isApplicationMaps()) {
        if((w.userData && w.userData.emailAddress && w.userData.organizationType === 'CAPSULE') || (w.mmap && w.mmap.isIntegratedMapsActive())) {
          this.onPropertyTypeRadioChange(w.mapData.propertyFilterSelectedRadio ? w.mapData.propertyFilterSelectedRadio : 'all');
        }
      }
      this.isPropertyOn = w.mapData.propertyFilterActive;
      this.glaSqftMin = w.mapData.glaSqftMin? w.mapData.glaSqftMin.toString(): this.glaSqftMin;
      this.glaSqftMax = w.mapData.glaSqftMax? w.mapData.glaSqftMax.toString(): this.glaSqftMax;
      this.availableSqftMin = w.mapData.availableSqftMin? w.mapData.availableSqftMin.toString(): this.availableSqftMin;
      this.availableSqftMax = w.mapData.availableSqftMax? w.mapData.availableSqftMax.toString(): this.availableSqftMax;
      (<any>window).Events.publish('detectChanges');
    });

    this.propertyTypeRadioSubscription = w.Events.subscribe('propertyTypeRadioChanged', (data)=>{
      if(data) {
        this.onPropertyTypeRadioChange(data);
      }
    });

    if(this.glaSqftMinElement) {
      Observable.fromEvent(this.glaSqftMinElement, 'input')
      .debounceTime(500)
      .distinctUntilChanged()
      .subscribe((e: any) => {
        this.runCall(this.glaSqftMin) && this.processPropertyFilter();
        this.glaSqftMin = this.glaSqftMin.replace(/\s/g,'');
        (<any>window).Events.publish('detectChanges');
      });
    }

    if(this.glaSqftMaxElement) {
      Observable.fromEvent(this.glaSqftMaxElement, 'input')
      .debounceTime(500)
      .distinctUntilChanged()
      .subscribe((e: any) => {
        this.runCall(this.glaSqftMax) && this.processPropertyFilter();
        this.glaSqftMax = this.glaSqftMax.replace(/\s/g,'');
        (<any>window).Events.publish('detectChanges');
      });
    }

    if(this.availableSqftMinElement) {
      Observable.fromEvent(this.availableSqftMinElement, 'input')
      .debounceTime(500)
      .distinctUntilChanged()
      .subscribe((e: any) => {
        this.runCall(this.availableSqftMin) && this.processPropertyFilter();
        this.availableSqftMin = this.availableSqftMin.replace(/\s/g,'');
        (<any>window).Events.publish('detectChanges');
      });
    }

    if(this.availableSqftMaxElement) {
      Observable.fromEvent(this.availableSqftMaxElement, 'input')
      .debounceTime(500)
      .distinctUntilChanged()
      .subscribe((e: any) => {
        this.runCall(this.availableSqftMax) && this.processPropertyFilter();
        this.availableSqftMax = this.availableSqftMax.replace(/\s/g,'');
        (<any>window).Events.publish('detectChanges');
      });
    }

    w.Events.subscribe('userTokenCompleted', (data)=> {
      if(w.mmap && w.mmap.isIntegratedMapsActive()) {
        this.getOrganizationDetails();
      } else {
        if(data && data.emailAddress && data.organizationType === 'CAPSULE') {
          this.organizationDetails = {
            organizationId: data.organizationId,
            name: data.organizationName
          }
        } else if(data && !data.emailAddress && this.organizationDetails) {
          this.organizationDetails = null;
        }
      }
      w.Events.publish('detectChanges');
    });

    this.propertyResetFilterSubscription = w.Events.subscribe('resetPropertyFilterInputs', ()=>{
      this.glaSqftMin = this.availableSqftMin = this.glaSqftMax = this.availableSqftMax = '';
    });
  }

  getOrganizationDetails() {
    let w = (<any>window);
    this.mapsSidebarService.getOrganizationDetails(w.mmap.customerId).subscribe((response)=>{
      this.organizationDetails = response;
      w.Events.publish('detectChanges');
    },(error)=>{
      throw(error);
    });
  }

  runCall(value) {
    return !(/^\s*$/.test(value)) || value === '';
  }

  processPropertyFilter(propertyTypeToggle?) {
    let w = (<any>window);
    this.resetFiltersError();
    if(this.validateFilters()) {
      w.contextualInfoWindow.closeAllInfoWindows();
      w.setMapDataProperty('glaSqftMin', !isNaN(parseInt(this.glaSqftMin.replace(/\,/g,'')))? parseInt(this.glaSqftMin.replace(/\,/g,'')): null);
      w.setMapDataProperty('glaSqftMax', !isNaN(parseInt(this.glaSqftMax.replace(/\,/g,'')))? parseInt(this.glaSqftMax.replace(/\,/g,'')): null);
      w.setMapDataProperty('availableSqftMin', !isNaN(parseInt(this.availableSqftMin.replace(/\,/g,'')))? parseInt(this.availableSqftMin.replace(/\,/g,'')): null);
      w.setMapDataProperty('availableSqftMax', !isNaN(parseInt(this.availableSqftMax.replace(/\,/g,'')))? parseInt(this.availableSqftMax.replace(/\,/g,'')): null);
      w.apiProperty.onFilterChange(propertyTypeToggle);
      w.leaderLines.showLeaderLines();
    }
    (<any>window).Events.publish('detectChanges');
    w.localStorageHandler.updateMapDataLocalStorage();
  }

  validateFilters() {
    //Number check
    this.glaSqftMinError = (!(/(?:^|\s)([0-9]*\.?[0-9]+|[0-9]{1,3}(?:,[0-9]{3})*(?:\.[0-9]+)?)(?!\S)/.test(this.glaSqftMin)) && this.glaSqftMin !== '');

    this.glaSqftMaxError = (!(/(?:^|\s)([0-9]*\.?[0-9]+|[0-9]{1,3}(?:,[0-9]{3})*(?:\.[0-9]+)?)(?!\S)/.test(this.glaSqftMax)) && this.glaSqftMax !== '');

    this.availableSqftMinError = (!(/(?:^|\s)([0-9]*\.?[0-9]+|[0-9]{1,3}(?:,[0-9]{3})*(?:\.[0-9]+)?)(?!\S)/.test(this.availableSqftMin)) && this.availableSqftMin !== '');

    this.availableSqftMaxError = (!(/(?:^|\s)([0-9]*\.?[0-9]+|[0-9]{1,3}(?:,[0-9]{3})*(?:\.[0-9]+)?)(?!\S)/.test(this.availableSqftMax)) && this.availableSqftMax !== '');

    //Min greater than max check

    if((this.glaSqftMin !== '' && this.glaSqftMax !== '') && (parseInt(this.glaSqftMin.replace(/\,/g,'')) > parseInt(this.glaSqftMax.replace(/\,/g,''))) ) {
      this.glaSqftMinError = true;
      this.glaSqftMaxError = true;
    }

    if((parseInt(this.availableSqftMin.replace(/\,/g,'')) > parseInt(this.availableSqftMax.replace(/\,/g,''))) && this.availableSqftMax !== '') {
      this.availableSqftMinError = true;
      this.availableSqftMaxError = true;
    }

    //Minimum length check

    this.glaSqftMaxLengthError = (this.glaSqftMax.length > 0 && (parseInt(this.glaSqftMax.replace(/\,/g,'')) < 99 || parseInt(this.glaSqftMax.replace(/\,/g,'')) > 10000000));

    this.availableSqftMaxLengthError = (this.availableSqftMax.length > 0 && (parseInt(this.availableSqftMax.replace(/\,/g,'')) < 9 || parseInt(this.availableSqftMax.replace(/\,/g,'')) > 10000000));

    return !(this.glaSqftMinError || this.glaSqftMaxError || this.availableSqftMinError || this.availableSqftMaxError || this.glaSqftMaxLengthError || this.availableSqftMaxLengthError);
  }

  toggleProperty(event) {
    let w = (<any>window),
    toggle = event.target ? event.target.checked : event;
    this.isPropertyOn = toggle;
    w.setMapDataProperty('propertyFilterActive', toggle);
    w.apiProperty.toggleMarkers();
    w.apiPropertyCluster.toggleMarkers();
    w.leaderLines.showLeaderLines();
    (<any>window).Events.publish('detectChanges');
    w.localStorageHandler.updateMapDataLocalStorage();
  }

  closeOnOutsideClick(event: Event) {
    if (event.target !== this.elementRef.nativeElement
        && !this.elementRef.nativeElement.contains(event.target)
        && !(<any>window).hasClass(event.target, 'layer-filter-sub-header')
        && !(<any>window).hasClass(event.target, 'toggle-layers-holder')
        && !(<any>window).hasClass(event.target, 'filter-counter')
        && !(<any>window).hasClass(event.target, 'filter-icon')
        && !(<any>window).hasClass(event.target, 'property-svg')
        && !(<any>window).hasClass(event.target, 'property-svg-inner-content')
        && !(<any>window).hasClass(event.target, 'arrow-icon')) {
        this.closePropertyFilter();
        document.removeEventListener('click', this.closeOnClickRef, true);
    }
  }

  closePropertyFilter() {
    this.mapsSidebarService.showPropertyFilter = false;
    (<any>window).Events.publish('detectChanges');
    (<any>window).localStorageHandler.updateSideBarToLS();
  }

  resetPropertyFilter() {
    let w = (<any>window);
    this.glaSqftMin = this.availableSqftMin = this.glaSqftMax = this.availableSqftMax = '';
    if(w.mmap.isIntegratedMapsActive() || this.showOrgPropertiesRadio()) {
      w.mmap.setInhibitLayer('property', 'public,profile');
      w.setMapDataProperty('propertyFilterSelectedRadio', 'org');
    }  
    this.resetFiltersError();
    this.processPropertyFilter();
    w.localStorageHandler.updateMapDataLocalStorage();
    w.Events.publish('detectChanges');
  }

  resetFiltersError() {
    this.glaSqftMinError = this.glaSqftMaxLengthError = this.availableSqftMaxLengthError =
    this.glaSqftMaxError = this.availableSqftMinError = this.availableSqftMaxError = false;
    (<any>window).Events.publish('detectChanges');
  }

  glaMaxFocus(value) {
    this.isGlaSqftMaxFocus = value;
    (<any>window).Events.publish('detectChanges');
  }

  availableMaxFocus(value) {
    this.isAvailableSqftMaxFocus = value;
    (<any>window).Events.publish('detectChanges');
  }

  resetPropertyGLAFilter() {
    this.glaSqftMin = this.glaSqftMax = '';
    this.glaSqftMinError = this.glaSqftMaxLengthError = this.glaSqftMaxError = false;
    this.processPropertyFilter();
  }

  resetAvailableSpaceFilter() {
    this.availableSqftMin = this.availableSqftMax = '';
    this.availableSqftMaxLengthError = this.availableSqftMinError = this.availableSqftMaxError = false;
    this.processPropertyFilter();
  }

  showPropertyGLAReset() {
    return (this.glaSqftMin && this.glaSqftMin !== '') || (this.glaSqftMax && this.glaSqftMax !== '');
  }

  showAvailableSpaceReset() {
    return (this.availableSqftMin && this.availableSqftMin !== '') || (this.availableSqftMax && this.availableSqftMax !== '');
  }

  onPropertyTypeRadioChange(filter) {
    let w = (<any>window);
    switch(filter) {
      case 'all':
      w.mmap.setInhibitLayer('property', 'profile');
      w.setMapDataProperty('propertyFilterSelectedRadio', 'all');
      break;

      case 'org':
      w.mmap.setInhibitLayer('property', 'public,profile');
      w.setMapDataProperty('propertyFilterSelectedRadio', 'org');
      break;
    };
    w.localStorageHandler.updateMapDataLocalStorage();
    this.processPropertyFilter(true);
    w.Events.publish('detectChanges');
  }

  isPropertyTypeRadioChecked(filter) {
    let w = (<any>window), returnValue;
    switch(filter) {
      case 'all':
      returnValue = this.showOrgPropertiesRadio()? !this.isOrgRadioActive(): true;
      break;

      case 'org':
      returnValue = this.isOrgRadioActive();
    };
    return returnValue;
  }

  isOrgRadioActive() {
    let w = (<any>window);
    return w.mmap.checkIfInhibitLayerActive('property', 'public') && w.mmap.checkIfInhibitLayerActive('property', 'profile');
  }

  showOrgPropertiesRadio() {
    let w = (<any>window);
    return (this.organizationDetails && this.organizationDetails.organizationId);
  }

  getOrganizationName() {
    return this.organizationDetails.name || 'Organization';
  }

  ngOnDestroy() {
    this.propertyFiltersChangedSubscription && this.propertyFiltersChangedSubscription.unsubscribe();
    this.propertyFilterActiveSubscription && this.propertyFilterActiveSubscription.unsubscribe();
    this.propertyFiltersToggleSubscription && this.propertyFiltersToggleSubscription.unsubscribe();
    this.propertyTypeRadioSubscription && this.propertyTypeRadioSubscription.unsubscribe();
    this.propertyResetFilterSubscription && this.propertyResetFilterSubscription.unsubscribe();
  }
}
  


// WEBPACK FOOTER //
// ./src/app/modules/maps-sidebar/components/property-filter/property-filter.component.ts